<template>
  <section :class="compact ? 'bg-transparent' : 'border-t border-default/60 bg-default'">
    <UContainer :class="compact ? 'p-0' : 'py-12 sm:py-14'">
      <div class="mx-auto max-w-md space-y-4">
        <h2
          v-if="!compact"
          class="text-center text-xl font-semibold"
        >
          {{ title || item?.title || 'نظرسنجی' }}
        </h2>
        <p
          v-if="subtitle && !compact"
          class="text-center text-sm text-muted"
        >
          {{ subtitle }}
        </p>
        <div
          v-if="!surveyId || builderPreview"
          class="rounded-2xl border border-dashed p-6 text-center text-sm text-muted"
        >
          نظرسنجی کوتاه
        </div>
        <LeadFlowShell
          v-else
          :labels="['سؤالات', 'موبایل']"
          :step="step"
          :loading="saving"
          :next-disabled="step === 1 && !isCompleteIrMobile(phone)"
          :show-next="!done"
          @next="next"
          @back="step = 0"
        >
          <LeadQuestionFields
            v-if="step === 0"
            v-model="answers"
            :questions="item?.questions ?? []"
          />
          <AuthPhoneInput
            v-else
            v-model="phone"
          />
          <p
            v-if="done"
            class="text-center text-sm text-primary"
          >
            {{ rewardCode ? `کد جایزه: ${rewardCode}` : 'نظر شما ثبت شد.' }}
          </p>
        </LeadFlowShell>
        <p
          v-if="error"
          class="text-center text-sm text-error"
        >
          {{ error }}
        </p>
      </div>
    </UContainer>
  </section>
</template>

<script setup lang="ts">
import AuthPhoneInput from '~/components/auth/PhoneInput.vue'
import type { LeadQuestion } from '~/utils/leads/questions'
import { isCompleteIrMobile } from '~/utils/phone'
import { apiErrorMessage } from '~/utils/apiError'

const props = defineProps<{
  title?: string
  subtitle?: string
  surveyId?: string
  builderPreview?: boolean
  compact?: boolean
}>()

const item = ref<{ title: string; questions: LeadQuestion[] } | null>(null)
const answers = ref<Record<string, unknown>>({})
const phone = ref('')
const step = ref(0)
const saving = ref(false)
const done = ref(false)
const rewardCode = ref<string | null>(null)
const error = ref('')

if (import.meta.client && props.surveyId && !props.builderPreview) {
  $fetch<{ item: NonNullable<typeof item.value> }>(`/api/leads/surveys/${props.surveyId}`)
    .then((res) => { item.value = res.item })
    .catch(() => {})
}

async function next() {
  if (step.value === 0) {
    step.value = 1
    return
  }
  if (!props.surveyId) return
  saving.value = true
  error.value = ''
  try {
    const res = await $fetch<{ item: { rewardCode: string | null } }>(`/api/leads/surveys/${props.surveyId}/submit`, {
      method: 'POST',
      body: { answers: answers.value, phone: phone.value },
    })
    rewardCode.value = res.item.rewardCode
    done.value = true
  }
  catch (err) {
    error.value = apiErrorMessage(err, 'ارسال ناموفق بود')
  }
  finally {
    saving.value = false
  }
}
</script>
